export enum RoutePath {
  ADMIN_PROFILE = '/admin',
  USER_PROFILE = '/profile',
  ITEM_PAGE = '/catalog/:slug',
  LOGIN = '/login',
  REGISTRATION = '/registration',
  CATALOG = '/catalog',
  CART = '/cart',
  HOME = '/',
  CHECKOUT = '/checkout',
  CHECKOUT_SUCCESSFUL = '/checkout/success',
  CONTACTS = '/contacts',
  LEATHERS = '/leathers',
  NOT_FOUND = '/not_found',
}
